export const useThrottle = (callback, delay) => {
    let waiting = false;
    return (...args) => {
        if (!waiting) {
            waiting = true;
            setTimeout(() => {
                waiting = false;
                callback(...args);
            }, delay);
        }
    };
};
